// extracted by mini-css-extract-plugin
module.exports = {"setContent":"_2bOF-","isRevampedLogo":"_3PFe2"};